import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import 'react-datepicker/dist/react-datepicker.css';
import ModalBorder from '../ModalBorder';
import { showCartModal } from '../../redux/actions';
import { getCreditCard } from '../../utils';
import { COLOR_LIGHT_GRAY } from '../../constants/configuration';
import { useAppDispatch, useAppSelector } from '../../redux/hook';
import CartModalFooter from './components/CartModalFooter';
import CartModalBody from './components/CartModalBody';
import moment from 'moment';

export default function CartModal({ stripe, elements }) {
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(false);
  const [choosePayment, setChoosePayment] = useState(false);
  const [dateState, setStateRaw] = useState({
    day: moment(),
    hourSelectValue: 0,
    selectTime: false,
    isValidDate: true,
  });
  const setDateState = (update) => setStateRaw((prevState) => ({ ...prevState, ...update }));

  const [isPhoneIncorrect, setIsPhoneIncorrect] = useState(false);
  const { user } = useAppSelector((state) => state.userReducer);
  const { cartModal } = useAppSelector((state) => state.componentReducer);
  const { sections } = useAppSelector((state) => state.shopReducer);


  const resetState = () => {
    setLoading(false);
    setChoosePayment(false);
    setDateState({
    day: null,
    hourSelectValue: 0,
    selectTime: false,
    isValidDate: true,
    });
    setIsPhoneIncorrect(false);
  };
 const { day, hourSelectValue, selectTime, isValidDate } = dateState

  return (
    <Modal
      onHide={() => {
        dispatch(showCartModal(false));
        resetState();
      }}
      show={cartModal}
      aria-labelledby='contained-modal-title-vcenter'
      centered
      scrollable
    >
      <ModalBorder
        className='hide-scroll modal-size-fixed'
        color={COLOR_LIGHT_GRAY}
      >

          <Modal.Body
            className='dark-modal'
          >
            <CartModalBody
              card={getCreditCard(user.cards)}
              choosePayment={choosePayment}
              stripe={stripe}
              elements={elements}
              selectTime={selectTime}
              setLoading={setLoading}
              isPhoneIncorrect={isPhoneIncorrect}
              setChoosePayment={setChoosePayment}
              sections={sections}
              day={day}
              setDateState={setDateState}
              isValidDate={isValidDate}
              hourSelectValue={hourSelectValue}
              setIsPhoneIncorrect={setIsPhoneIncorrect}
              loading={loading}
            />
          </Modal.Body>
          <Modal.Footer className='modal-sticky-footer d-flex justify-content-center dark-modal'>
            <CartModalFooter
              resetState={resetState}
              choosePayment={choosePayment}
              setChoosePayment={setChoosePayment}
              loading={loading}
              setLoading={setLoading}
              setDateState={setDateState}
            />
          </Modal.Footer>
      </ModalBorder>
    </Modal>
  );
}
